import { AIRPORT_CITY, MARKET, RESIDENTIAL, RING_ROAD, TOWN } from './streetscapes';
import type { Route } from './types';

/** The first route: Circle → Ring Road → Osu → Cantonments → Liberation Road → Airport, and back. */
export const CIRCLE_AIRPORT: Route = {
  id: 'circle-airport',
  name: 'Circle ⇄ Airport',
  from: 'Circle',
  to: 'Airport',
  length: 5000,
  legs: [
    { id: 'circle', name: 'Kwame Nkrumah Circle', subtitle: 'Under the interchange', start: 0, end: 900, traffic: 1.2, streetscape: MARKET },
    { id: 'ringroad', name: 'Ring Road', subtitle: 'Kokomlemle to Kanda', start: 900, end: 2100, traffic: 1.0, streetscape: RING_ROAD },
    { id: 'osu', name: 'Oxford Street, Osu', subtitle: 'Danquah Circle', start: 2100, end: 3000, traffic: 1.1, streetscape: TOWN },
    { id: 'cantonments', name: 'Cantonments', subtitle: 'Labone to Burma Camp', start: 3000, end: 4000, traffic: 0.7, streetscape: RESIDENTIAL },
    { id: 'liberation', name: 'Liberation Road', subtitle: '37 to the Airport', start: 4000, end: 5000, traffic: 0.9, streetscape: AIRPORT_CITY },
  ],
  stops: [
    { id: 'circle', name: 'Circle', at: 180, crowd: [5, 9] },
    { id: 'odawna', name: 'Odawna', at: 620, crowd: [2, 5] },
    { id: 'kokomlemle', name: 'Kokomlemle', at: 1120, crowd: [2, 5] },
    { id: 'paloma', name: 'Paloma', at: 1480, crowd: [3, 6] },
    { id: 'kanda', name: 'Kanda', at: 1860, crowd: [2, 5] },
    { id: 'danquah', name: 'Danquah Circle', at: 2260, crowd: [3, 6] },
    { id: 'oxford', name: 'Oxford Street', at: 2660, crowd: [4, 7] },
    { id: 'labone', name: 'Labone', at: 3160, crowd: [2, 4] },
    { id: 'cantonments', name: 'Cantonments', at: 3520, crowd: [2, 5] },
    { id: 'burma', name: 'Burma Camp', at: 3860, crowd: [2, 4] },
    { id: '37', name: '37 Station', at: 4260, crowd: [4, 8] },
    { id: 'airport', name: 'Airport', at: 4720, crowd: [5, 9] },
  ],
  junctions: [
    { id: 'kn-ave', name: 'Kwame Nkrumah Ave junction', at: 420 },
    { id: 'nima', name: 'Nima junction', at: 1300 },
    { id: 'kanda', name: 'Kanda junction', at: 1700 },
    { id: 'oxford', name: 'Oxford Street junction', at: 2460 },
    { id: 'cantonments-rd', name: 'Cantonments Road junction', at: 3340 },
    { id: 'fourth-circular', name: 'Fourth Circular junction', at: 3700 },
    { id: '37', name: '37 junction', at: 4060 },
  ],
  stations: [
    { id: 'kente-fuel', name: 'Kente Fuel', at: 840 },
    { id: 'sankofa-oil', name: 'Sankofa Oil', at: 2780 },
    { id: 'osu-oil', name: 'Osu Oil', at: 4480 },
  ],
};
